module.exports = __webpack_public_path__ + "img/icon-item-spray.878a9709.svg";